module.exports = __webpack_public_path__ + "img/result-detail-output-title.c14e070d.svg";